import { call, put, takeEvery } from 'redux-saga/effects';
import { GET_USER_EMAIL_REQUEST } from '../../constants/user_emails.constants';
import { getUserProfileEmails } from '../../../requests/user_emails_requests/get_user_email_request';
import { getUserEmailRequestSuccess, getUserEmailRequestFailure } from '../../actions/user_emails_actions/get_user_email.actions';
import { message_error } from '../../../../../../components/Message';

function* getUserProfileEmailsRequest({ id }) {
    const { result, error, options } = yield call(getUserProfileEmails, id);
    if (result) {
        yield put(getUserEmailRequestSuccess(options.person.emails));
    } else {
        yield put(getUserEmailRequestFailure(error));
        message_error(error);
    }
}

export default function* getUserEmailSaga() {
    yield takeEvery(GET_USER_EMAIL_REQUEST, getUserProfileEmailsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/get_user_email.saga.js